import { createVanIconComponent } from "./van"

const PhoneOutlined = createVanIconComponent("phone-o")
export default PhoneOutlined
